
export function transformDepValue(obj, trans) {
  if (typeof obj === 'string') {
    return trans(obj, trans)
  }
  return Object.keys(obj)
    .reduce((acc, current) => {
      const val = obj[current]
      if (typeof val === 'object') {
        acc[current] = transformDepValue(val, trans)
      } else if (typeof val === 'string') {
        acc[current] = trans(val)
      } else {
        acc[current] = val
      }
      return acc
    }, {})
}
